import * as serverReq from "./selectedInstrumentCrud";
import {selectedInstrumentSlice} from "./selectedInstrumentSlice";
import {errorMessage} from "../../../../util/Helpers"

const {actions} = selectedInstrumentSlice;


/* Api Request Error Handler */
const errorHandler = dispatch => error => {
  if (error?.message && error.message === "Cancel Request" ) return;
  dispatch(actions.instrumentNotification({ notification: {type: "error", message: errorMessage(error)}}));
}

export const clearNotification = _ => dispatch => dispatch(actions.instrumentNotification({notification: null}));

/* Load Instrument Details Handler */
export const fetchInstrumentDetails = instrumentId => dispatch => {
  serverReq.getInstrumentDetails(instrumentId)
            .then(({data}) =>  dispatch(actions.instrumentDetailsFetched({ ...data })))
            .catch(errorHandler(dispatch));
};

